/**
 * Recebe um numero formatado em string e retorna em float: Ex: 1.400,15 se torna 1400.15
 * @param n
 * @param decimals
 * @returns
 */
export const numeroToNumber = function (n, decimals = 2) {
    if (typeof n !== "string") {
        return 0.0;
    }
    var num = n
        .replace(/[^0-9\.,\-]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
    if (n)
        num = Number(num).toFixed(decimals);
    return Number(num);
};
/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
const format = function (myNumber, n, x, s, c) {
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")", num = myNumber.toFixed(Math.max(0, ~~n));
    return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","));
};
/**
 * Recebe um float e retorna formatado: Ex: 1400.15 se torna 1.400,15
 * @param n
 * @param decimals
 * @returns
 */
export const numberToNumero = function (myNumber, prefixo = "", decimals = 2) {
    return prefixo + format(myNumber, decimals, 3, ".", ",");
};
export const moneyToReais = (money) => {
    return numberToNumero(money, "R$ ");
};
export const moneyToReaisSimplificado = (money) => {
    let out = "";
    if (money >= 1e6) {
        out = (money / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    }
    else if (money >= 1e3) {
        out = (money / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
    }
    else {
        out = numberToNumero(money);
    }
    return "R$ " + out;
};
/**
 * Remove todos os acentos e caracteres especiais de uma string
 * @param str
 * @returns
 */
export const removeAccents = (str = "") => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
export function intlNumber2Currency(n) {
    const locale = document.querySelector("html")?.getAttribute("lang")?.replace("_", "-") ??
        "pt_BR";
    const currencyCode = document
        .querySelector("meta[name=locale-currency-code]")
        ?.getAttribute("content") ?? "BRL";
    const obj = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
    }).format(n);
    let output = obj.toString();
    if (n < 0) {
        const prefix = n
            .toLocaleString(locale, {
            style: "currency",
            currency: currencyCode,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
            .replace(/\d/g, "")
            .trim();
        const positivePrefix = intlGetCurrencySymbol();
        output = positivePrefix + " -" + output.replace(/[^0-9\.\,]/g, "");
    }
    return output;
}
export function intlGetCurrencySymbol() {
    const locale = document.querySelector("html")?.getAttribute("lang")?.replace("_", "-") ??
        "pt_BR";
    const currency = document
        .querySelector("meta[name=locale-currency-code]")
        ?.getAttribute("content") ?? "BRL";
    return (0)
        .toLocaleString(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
        .replace(/\d/g, "")
        .trim();
}
export function converteData(data) {
    if (!data)
        return data;
    var parts = data.match(/(\d+)/g);
    if (!parts[2]) {
        console.log("String inválida para conversão de data!");
        return "";
    }
    if (parts[2].length === 4) {
        //data em formato dd/mm/yyyy
        return parts[2] + "-" + parts[1] + "-" + parts[0];
    }
    else if (parts[0].length === 4) {
        //data em formato yyyy-mm-dd
        return parts[2] + "/" + parts[1] + "/" + parts[0];
    }
    else {
        console.log("String inválida para conversão de data.");
    }
}
export function converteDataHora(data) {
    if (!data)
        return data;
    var parts = data.match(/(\d+)/g);
    if (!parts[3] || !parts[4]) {
        console.log("String inválida para conversão de data/hora!");
        return "";
    }
    if (parts[2].length === 4) {
        //data em formato dd/mm/yyyy
        return (parts[2] +
            "-" +
            parts[1] +
            "-" +
            parts[0] +
            " " +
            parts[3] +
            ":" +
            parts[4]);
    }
    else if (parts[0].length === 4) {
        //data em formato yyyy-mm-dd
        return (parts[2] +
            "/" +
            parts[1] +
            "/" +
            parts[0] +
            " " +
            parts[3] +
            ":" +
            parts[4]);
    }
    else {
        console.log("String inválida para conversão de data/hora.");
    }
}
/**
 * Adiciona <wbr> em todas as barras de uma string para ajudar o css a quebrar a linha
 * @param texto
 * @returns
 */
export function addWbr(texto) {
    let out = texto.replace("/", "/<wbr>");
    return out;
}
export default {};
